import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import LayoutView from "../layout/LayoutView.vue";
import { hideUI, Modal } from "@/ui";
import { getToken } from "@/common/storage";

const base = "/";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: LayoutView,
    redirect: "/homepage",
    children: [
      {
        path: "homepage",
        name: "Homepage",
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
        meta: { title: "首页" },
      },
      {
        path: "approval",
        name: "Approval",
        component: () =>
          import(
            /* webpackChunkName: "approval" */ "../views/ApprovalView.vue"
          ),
        meta: { title: "申报审批" },
      },
      {
        path: "apply",
        name: "Apply",
        component: () =>
          import(/* webpackChunkName: "apply" */ "../views/ApplyView.vue"),
        meta: { title: "国际会议申请" },
      },
      {
        path: "principle",
        name: "Principle",
        component: () =>
          import(
            /* webpackChunkName: "principle" */ "../views/PrincipleView.vue"
          ),
        meta: { title: "办会原则" },
      },
      {
        path: "solution",
        name: "Solution",
        component: () =>
          import(
            /* webpackChunkName: "solution" */ "../views/SolutionView.vue"
          ),
        meta: { title: "解决方案" },
      },
      {
        path: "service",
        name: "Service",
        component: () =>
          import(/* webpackChunkName: "service" */ "../views/ServiceView.vue"),
        meta: { title: "产品服务" },
      },
      {
        path: "information",
        name: "Information",
        component: () =>
          import(
            /* webpackChunkName: "information" */ "../views/InformationView.vue"
          ),
        meta: { title: "“遇”杭州" },
      },
      {
        path: "mine",
        name: "Mine",
        component: () =>
          import(/* webpackChunkName: "mine" */ "../views/MineView.vue"),
        meta: { title: "关于我们" },
      },
      {
        path: "/apply/form",
        name: "ApplyForm",
        component: () =>
          import(/* webpackChunkName: "apply-form" */ "../views/ApplyForm.vue"),
        meta: { title: "国际会议预审批", auth: true },
      },
      {
        path: "/my",
        name: "My",
        component: () =>
          import(/* webpackChunkName: "my" */ "../views/UserCenter.vue"),
        meta: { title: "我的", auth: true },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/LoginView.vue"),
    meta: { title: "登陆/注册" },
  },
];

const router = createRouter({
  history: createWebHistory(base),
  routes,
  // 每次切换路由的时候滚动到页面顶部
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  hideUI();
  if (to.meta.auth && !getToken()) {
    Modal({
      title: "提示",
      content: "您尚未登陆，请先登陆",
      cancelBtn: false,
      onConfirm: () => {
        next({ name: "Login", query: { r: to.path } });
      },
    });
  } else {
    next();
  }
});

export default router;
